import assetsIconsMapJson from '../../../images/icons/assets/map.json';

const DEFAULT_ASSET_ICON: string = '#asset-placeholder';

const ASSET_ICONS_MAP: {[assetSymbol: string]: string} = assetsIconsMapJson;

export const getAssetIcon = (assetSymbol: string): string =>
    assetSymbol && ASSET_ICONS_MAP[assetSymbol.toUpperCase()] || DEFAULT_ASSET_ICON;
